import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import {
    ORFButton
    , ORFDatePicker
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions
} from '../../../../../common/forms/order-request-form.component';
import { Row, Col } from 'react-bootstrap';
import { wirelineTerminateExhibitBActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate/wireline-terminate-exhibit-b.reducer";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../../common/file-attachment/file-attachment.component';

class WirelineTerminateExhibitB extends Component {
    constructor(props) {
        super(props);
        this.state = {
            terminateDate: '',
            localToggle: false,
            alterToggle: false,
        }
    }
    componentWillUnmount() {
        this.props.resetFileAttachment();
    }
    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems, uploadFile, saveOrderFile} = this.props;

        var success = await submitRequest(this.state.terminateDate);
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        this.setState({
            clearAttachment: true
        });

        if (modalClose) {
            modalClose();
        }
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    setTerminateDate = (v) => {
        this.setState({
            terminateDate: v
        });
    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    render() {

        const {
            //form
            wirelineTerminateCircuitFormB
            //reducer action
            , onSubscriptionSelect
            , fetchSubscriptionByValue
        } = this.props;

        const { subscriptionList } = this.props.createRequest;
        const { formSubmitted, subscription } = this.props.wirelineTerminateExhibitBRequest;
        const { terminateDate } = this.state;

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineTerminateCircuitFormB"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineTerminateCircuitFormB.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')} *`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                            />
                            {wirelineTerminateCircuitFormB.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                    {subscription.PlanName} <span>&#8226;</span> {subscription.VendorName} <span>&#8226;</span> {subscription.SimName}
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <ORFDatePicker label={`${this.toLocaleLanguage('terminate_date')} *`}
                                value={terminateDate}
                                action={this.setTerminateDate}
                                disabled={wirelineTerminateCircuitFormB.circuitId == 0}
                                minDate={new Date()}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')} *`}
                                fieldProp='.businessJustification'
                                value={wirelineTerminateCircuitFormB.businessJustification}
                                disabled={wirelineTerminateCircuitFormB.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={<Translation translationKey="additional_information" />}
                                fieldProp='.additionalInformation'
                                value={wirelineTerminateCircuitFormB.additionalInformation}
                                disabled={wirelineTerminateCircuitFormB.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <FileAttachment />
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={<Translation translationKey="modal_close_cancel_button" />}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={<Translation translationKey="submit_request_button" />}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={wirelineTerminateCircuitFormB.circuitId == 0
                                        || terminateDate == ''
                                        || wirelineTerminateCircuitFormB.businessJustification == ''
                                        || formSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelineTerminateExhibitBRequest, createRequest, translation } = state;
        const { wirelineTerminateCircuitFormB } = state.form;
        return {
            wirelineTerminateExhibitBRequest
            , wirelineTerminateCircuitFormB
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineTerminateExhibitBActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions),
            dispatch
        )
)(WirelineTerminateExhibitB);